import { render, staticRenderFns } from "./detail-new-route.vue?vue&type=template&id=35a314fb&scoped=true&"
import script from "./detail-new-route.vue?vue&type=script&lang=js&"
export * from "./detail-new-route.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a314fb",
  null
  
)

export default component.exports